import { render } from "./legoBadge.vue?vue&type=template&id=70feb1c4"
import script from "./legoBadge.vue?vue&type=script&lang=js"
export * from "./legoBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoBadge/legoBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70feb1c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70feb1c4', __exports__)) {
    api.reload('70feb1c4', __exports__)
  }
  
  module.hot.accept("./legoBadge.vue?vue&type=template&id=70feb1c4", () => {
    api.rerender('70feb1c4', render)
  })

}


export default __exports__